import Table from './Table'
import TableColumn from './TableColumn'
import TableHead from './TableHead'
import TableRow from './TableRow'

Table.Column = TableColumn
Table.Row = TableRow
Table.Head = TableHead

export default Table;
